/**
 * Portal Shell - Entry point for the portal shell functionality
 *
 * Re-exports main functionality and initializes portal-specific features.
 */

// Import core services
import { api } from '@services/api.js';
import { athleteService } from '@services/athletes.js';
import { invoiceService } from '@services/invoices.js';
import * as utils from '@utils/index.js';

// Export for ES module usage
export { api, athleteService, invoiceService, utils };

console.info('Portal Shell module loaded');
